import Interieur from "./Interieur";
import Schublade from "./Schublade";
import ClosedInterval from "oc-commons/ClosedInterval";
import Maths from "oc-commons/Maths";
import Brett from "./Brett";

export default class Schubladenbox extends Interieur {

    // persistent (UserLayer) ------------------------------------------

    faecherAnzahl = 1;
    faecherHoehe = 20; // Das ist die FRONTHOEHE - auch bei innenliegenden (die keine Front haben).
    isDropped = false;

    // transient (CompiledLayer) ---------------------------------------

    drawers = [];
    abstandsbretter: Brett[] = [];

    insets = {
        top: 2,
        bottom: 2,
    };

    ueberstand = {
        top: 0,
        bottom: 0,
    }

    frontBox = new THREE.Box3();

    _copied = false;

    constructor(type, element) {
        super(type, element);
    }

    get hasFronts() {
        return 'innenliegend' !== this.product.Art;
    }

    // canOverlay(other:Interieur) {
    //     return other===this || !(this.hasFronts && other.hasFronts);
    // }

    get hasGriffe() {
        return 'innenliegend' !== this.product.Art;
    }

    get interieur() {
        return this;
    }

    getFrontOffset() {
        const aufschlagend = APP.settings.getFloat('aussenwand_vorsprung') == 0.0;
        return aufschlagend ? APP.settings.getFloat('brett_staerke') : 0;
    }

    fromJSON(json) {
        super.fromJSON(json);
        this.faecherAnzahl = json.faecherAnzahl || 1;
        this.faecherHoehe = json.faecherHoehe || 20;
        this.isDropped = true;
        return this;
    }

    toJSON() {
        const json = super.toJSON();
        json.faecherAnzahl = this.faecherAnzahl;
        json.faecherHoehe = this.faecherHoehe;
        return json
    }

    copy(schubladenbox,createInterceptor) {
        super.copy(schubladenbox,createInterceptor);
        this.faecherAnzahl = schubladenbox.faecherAnzahl;
        this.faecherHoehe = schubladenbox.faecherHoehe;
        this.isDropped = schubladenbox.isDropped;
        // this._copied = true;
        return this;
    }

    _compileSize() {
        super._compileSize();

        const layout = this._getLayout();
        this.ueberstand = layout.ueberstand;
        this.size.y = layout.hoehe;
        
        // Fix Me?
        /* if (this.element && this.element.konstruktionsboeden && (this.size.y - 0.01) > this.element.size.y) {
            const newSize = this.calcFaecherHoehe(this.faecherAnzahl, this.faecherHoehe);
            this.setFaecher(newSize.anzahl, newSize.hoehe);
        } */
    }

    getHeight(bottom, top) {
        return this._getHeight(bottom, top).hoehe;
    }

    compileInternals() {
        super.compileInternals();
        const fuge = APP.settings.getMinValue('fugen_abstand');
        const brettStaerke = APP.settings.getFloat('front_staerke');
        const lazyDrawers = APP.model.lazyPool(this, 'drawers', () => new Schublade(this));

        // Die Koordinaten der Schublade sind im lokalen Koordinatensystem der Schubladenbox

        // Zu innenliegenden SK:
        // Wenn der Schubkasten eine Höhe von 200mm hat, ist das inkl. 30 mm Eingrifffuge.
        // Unten kommen noch 4 mm Fuge des unteren Schubkastens zum Boden hin dazu.
        // Bei 4 Schubkästen ist das Zwischenmaß also 4 x 200mm + 4mm Fuge unten = 804mm.

        let drawerBox = this.boxLocal;

        this._compileAbstandsbretter(drawerBox);

        let drawerOuterHeight = this.hasFronts
            ? (
                this.size.y
                + (this.ueberstand.bottom + this.ueberstand.top)
                - (fuge * (this.faecherAnzahl-1))
              ) / this.faecherAnzahl
            : ( this.size.y - fuge ) / this.faecherAnzahl;

        let yOuter = this.hasFronts ? -this.ueberstand.bottom : fuge;

        _.range(this.faecherAnzahl).forEach(i => {
            const drawer = lazyDrawers.next();

            drawer.front.box.copy(drawerBox);

            drawer.front.box.min.y = yOuter;
            yOuter += drawerOuterHeight;
            drawer.front.box.max.y = yOuter;
            yOuter += this.hasFronts ? fuge : 0;

            drawer.inner.box.copy(drawerBox);
            drawer.inner.box.max.z -= APP.settings.getFloat('aussenwand_vorsprung');

            const innerMinY = drawerBox.min.y+this.insets.bottom;
            const innerMaxY = drawerBox.max.y-this.insets.top;
            drawer.inner.box.min.y = Maths.cutBetween(innerMinY,drawer.front.box.min.y+this.insets.bottom,innerMaxY);
            drawer.inner.box.max.y = Maths.cutBetween(innerMinY,drawer.front.box.max.y-this.insets.top,innerMaxY);

            if (this.hasFronts) {
                if (this.element) {
                    drawer.front.box.min.x = drawer.schubladenbox.getFrontUeberstand(drawer.element.wallLeft, 'min', 'x');
                    drawer.front.box.max.x = drawer.schubladenbox.getFrontUeberstand(drawer.element.wallRight, 'max', 'x');
                }
            } else {
                let leftOffset = brettStaerke;
                let rightOffset = brettStaerke;
                if (this.element && this.element.getDoors().length > 0) {
                    if (this.element.getDoors().some(d=>d.getSide() === 'links' || d.getSide() === 'beide')) {
                        leftOffset += brettStaerke;
                    }
                    if (this.element.getDoors().some(d=>d.getSide() === 'rechts' || d.getSide() === 'beide')) {
                        rightOffset += brettStaerke;
                    }
                }
                drawer.inner.box.min.x += (APP.settings.getFloat('schublade_innen_seitlich') + leftOffset);
                drawer.inner.box.max.x -= (APP.settings.getFloat('schublade_innen_seitlich') + rightOffset);
                drawer.inner.box.max.y -= (APP.settings.getFloat('schublade_innen_eingriff'));
                drawer.inner.box.max.z -= (APP.settings.getFloat('schublade_innen_ruecksprung') + brettStaerke);

                drawer.front.box.min.x = drawer.inner.box.min.x - brettStaerke;
                drawer.front.box.max.x = drawer.inner.box.max.x + brettStaerke;

                drawer.front.box.max.y = drawer.inner.box.max.y + brettStaerke;
            }

            drawer.front.box.min.z = drawer.inner.box.max.z;
            drawer.front.box.max.z = drawer.inner.box.max.z + brettStaerke;

            drawer.inner.boxToVertices();
            drawer.front.boxToVertices();

            drawer.isTop = i === this.faecherAnzahl - 1;
            drawer.isBottom = i === 0;
        });
        lazyDrawers.cleanup();
        this.drawers.forEach(x => x.compile());
    }

    _compileAbstandsbretter(drawerBox) {
        if (this.hasFronts ||
            !this.arrangement.isSchwebetuerOrShoji() ||
            !this.element) {
            return;
        }

        const brettStaerke = APP.settings.getFloat('brett_staerke');
        const schwebetuer_schubkasten_innenliegend_seitenabstand = APP.settings.getFloat('schwebetuer_schubkasten_innenliegend_seitenabstand',5);

        const abstandsbretter = APP.model.lazyPool(this, 'abstandsbretter', () => {
            const brett = new Brett(this, 'Abstandsbrett', 'yz');
            return brett;
        });

        ['wallLeft','wallRight'].forEach(wall=>{
            if (!this.element[wall].isInner || this.element[wall].product.Artikelnummer === 'Trennwand') {
                return;
            }
            const left = wall === 'wallLeft';
            const abstandsbrett = abstandsbretter.next();
            if (left) {
                drawerBox.min.x += (schwebetuer_schubkasten_innenliegend_seitenabstand + brettStaerke);
            } else {
                drawerBox.max.x -= (schwebetuer_schubkasten_innenliegend_seitenabstand + brettStaerke);
            }
            abstandsbrett.box.copy(drawerBox);
            if (left) {
                abstandsbrett.box.min.x = drawerBox.min.x - brettStaerke;
                abstandsbrett.box.max.x = drawerBox.min.x;
            } else {
                abstandsbrett.box.min.x = drawerBox.max.x;
                abstandsbrett.box.max.x = drawerBox.max.x + brettStaerke;
            }
            abstandsbrett.boxToVertices();
            abstandsbrett.compile();
        });

        abstandsbretter.cleanup();
    }

    compileFront() {
        this.drawers.forEach(x => x.compileFront());
        this.frontBox.makeEmpty();
        this.drawers.forEach(x => this.frontBox.union(x.front.box));
    }

    setFromProduct(product) {
        this.product = product;
        this.drawers = [];
        this.abstandsbretter = [];

        this.compile();
        this.compileInternals();
        this.compileFront();
        APP.model.setDirty();
    }

    get maxFaecher() {
        if (!this.element) {
            return 0;
        }
        const fuge = APP.settings.getMinValue('fugen_abstand');
        const fit = this.element.getInterieurYFitAtPos(this);
        return (fit.maxCollapse - fit.minCollapse) / (APP.settings.getMinValue('schublade_hoehe') + fuge);
    }


    setFaecher(anzahl, hoehe) {
        const calc = this.calcFaecherHoehe(anzahl, hoehe);
        if (calc.anzahl===0) {
            APP.model.maybeThrowCompileError(this,'Keine passende Schublade', 'Es gibt für dieses Fach keine passende Schubladenbox');
        }
        this.faecherAnzahl = calc.anzahl;
        this.faecherHoehe = calc.hoehe;
        this._compileSize();
        const fit = this.element.getInterieurYFitAtPos(this);
        const freieFachHoehe = APP.settings.getMinValue('fach_hoehe');
        const zuTief = fit.minCollapse - this.getSchrankY();
        if (zuTief > -freieFachHoehe) {
            this.setSchrankY(fit.minCollapse);
        }
        this._compileSize();
        /**
         * ---  Hier wird geprüft ob die aufaddierten Fächer größer sind als maxCollapse - minCollapse
         *      Wenn dem so ist, dann muss die Schubladenbox-Position mittig positioniert werden.
         * ---  Wenn dann die Schubladenbox ganz oben angelegt ist, wird noch eine Korrektur ähnlich der
         *      zuTief Logik angewandt (s.o.)
         */
        const buffer = this.getSchrankY() + this.size.y - fit.maxCollapse;
        const zuHoch = this.faecherAnzahl * this.faecherHoehe > fit.maxCollapse - fit.minCollapse
        if(zuHoch) {
            this.setSchrankPositionY((fit.maxCollapse + fit.minCollapse) / 2);
        } else if (buffer > -freieFachHoehe) {
            this.setSchrankPositionY(this.getSchrankPositionY() - buffer);
        }
    }

    /**
     * Gibt die realisierbare Hoehe und Anzahl zurück. Die Anzahl wird möglichst beibehalten.
     * @param anzahl
     * @param wunschhoehe
     * @returns {anzahl,hoehe}
     */
    calcFaecherHoehe(anzahl, wunschhoehe) {
        if (!this.element) {
            return;
        }

        const epsilon = 0.0001;
        const fuge = APP.settings.getMinValue('fugen_abstand');
        const fit = this.element.getInterieurYFitAtPos(this);

        // Hier gibt es eine Reihe von Bedingungen zu beachten
        // - min/max Werte für die Höhe einer einzelnen Schublade
        // - kollabierender Bereich oben und/oder unten
        // - Fach-Mindesthöhen
        // - Höhe der Front ist abhängig von angrenzendem Deckel oder Boden
        // - die Position der Schublade sollte nach Möglichkeit beibehalten werden

        // Es muss also sowohl die Position als auch die Höhe beachtet werden, und es gibt Sprünge.
        // Das Einpassen der Höhe hat Priorität von der Position.
        // Die Position wird von dieser Methode nicht ermittelt, nur, ob es überhaupt eine gültige Höhe (und Anzahl) gibt

        const touches = {
            bottom: Math.abs(fit.minCollapse - this.element.box.min.y) < epsilon,
            top: Math.abs(fit.maxCollapse - this.element.box.max.y) < epsilon,
        }
        const ueberstand = {
            collapsed: this._getUeberstand(touches.bottom, touches.top),
            uncollapsed: this._getUeberstand(false, false),
        }

        const collapseSpace = {
            bottom: fit.min - fit.minCollapse,
            top: fit.maxCollapse - fit.max,
        }
        const innerHoehe = fit.max - fit.min;

        // Die folgenden Intervalle geben die erlaubten von-bis Bereiche der Front-Höhe der gesamten Schubladenbox inklusiv Überstand an
        // Die Fach-Höhen werden dadurch grundsätzlich berücksichtigt, unter der Voraussetzung, dass die Position
        // nachträglich richtig gesetzt wird
        const frontHeightIntervals = [];
        // 1. Fall - Passt komplett rein, dadurch ist die position festgelegt: muss oben und unten anschliessen
        frontHeightIntervals.push([
            collapseSpace.bottom + collapseSpace.top + innerHoehe + ueberstand.collapsed.bottom + ueberstand.collapsed.top,
            collapseSpace.bottom + collapseSpace.top + innerHoehe + ueberstand.collapsed.bottom + ueberstand.collapsed.top]);
        // 2. Fall - position festgelegt: muss unten anschliessen
        frontHeightIntervals.push([
            collapseSpace.bottom + ueberstand.collapsed.bottom + ueberstand.uncollapsed.top,
            collapseSpace.bottom + innerHoehe + ueberstand.collapsed.bottom + ueberstand.uncollapsed.top]);
        // position festgelegt: muss oben anschliessen
        frontHeightIntervals.push([
            collapseSpace.top + ueberstand.uncollapsed.bottom + ueberstand.collapsed.top,
            collapseSpace.top + innerHoehe + ueberstand.uncollapsed.bottom + ueberstand.collapsed.top]);
        // position frei innerhalb der innerHoehe-hoehe
        frontHeightIntervals.push([0, innerHoehe + ueberstand.uncollapsed.bottom + ueberstand.uncollapsed.top]);

        // Rückrechnung von einer Gesamthöhe auf die Höhe einer einzelnen Schublade
        const einzelHoeheBeiGesamterFrontHeight =
                this.hasFronts
                    ? h => (h - (anzahl - 1) * fuge) / anzahl
                    : h => (h - fuge) / anzahl;


        // Die Intervalle auf gültige Schubladenhöhen begrenzen
        const schubladenHoeheInterval = [APP.settings.getMinValue('schublade_hoehe'),APP.settings.getMaxValue('schublade_hoehe')];
        const singleHeightIntervals = frontHeightIntervals.map(i=>{
            const einzelHoeheIntervall = i.map(h=>einzelHoeheBeiGesamterFrontHeight(h));
            return ClosedInterval.intersection(schubladenHoeheInterval,einzelHoeheIntervall);
        }).filter(i=>i!=null);

        // Wenn es kein gültiges Intervall gibt, tja... dann wohl leider nicht. Wir probieren es mit einer anderen Anzahl
        // an Schubladen rekursiv noch mal
        if (singleHeightIntervals.length===0) {
            if (anzahl>1) {
                const result = this.calcFaecherHoehe(anzahl-1, wunschhoehe);
                if (result) {
                    return result;
                }
            }
            if (anzahl<innerHoehe/schubladenHoeheInterval[0]) {
                const result = this.calcFaecherHoehe(anzahl+1, wunschhoehe);
                if (result) {
                    return result;
                }
            }
            return {anzahl: 0, hoehe: 0};
        }

        // Wenn die Wunschhöhe in einem der Intervalle liegt => passt!
        if (singleHeightIntervals.some(i=>i[0]-epsilon<=wunschhoehe && wunschhoehe<=i[1]+epsilon)) {
            return {anzahl, hoehe: wunschhoehe};
        }

        // Ansonsten ändere die Höhe auf die nächste Intervallgrenze
        const grenzen = _.flatten(singleHeightIntervals);
        const intervallgrenze = _.minBy(grenzen,h=>Math.abs(h-wunschhoehe));
        return {anzahl, hoehe: intervallgrenze};
    }

    _getLayout(anzahl = this.faecherAnzahl, hoehe = this.faecherHoehe, y = this.y) {
        // falls die Schublade zu hoch sitzt, wird sie vorab nach unten verschoben
        // wichtig für die Anwendung im Dialog.
        const fuge = APP.settings.getMinValue('fugen_abstand');
        const brettStaerke = APP.settings.getFloat('brett_staerke');

        /* const fit = this.element.getInterieurYFitAtPos(this);
        const touches = {
            bottom: Math.abs(fit.minCollapse - this.element.box.min.y) < epsilon,
            top: Math.abs(fit.maxCollapse - this.element.box.max.y) < epsilon,
        } */

        // FIXME das ist aber nur für die Aussenliegende Schublade gültig, oder?
        const frontHoehe = anzahl * hoehe + (anzahl - 1) * fuge;

        /* if (this.element) {
            const zuHoch = y + frontHoehe - brettStaerke - this.element.slopeTop;
            if (zuHoch > 0) {
                y -= zuHoch;
            }
        } */

        const EPSILON = brettStaerke*2;

        const bottom = !this.element || y <= this.element.box.min.y + EPSILON;
        const top = !this.element || y - this.ueberstand.bottom + frontHoehe > this.element.box.max.y - EPSILON;
        return this._getHeight(bottom, top, anzahl, hoehe);
    }

    /**
     * Berechnet die Höhe der Schubladenbox abhängig davon, ob sie an Boden oder Deckel angrenzt
     * (und daher andere Überstände und damit eine andere Höhe hat). Ergebnis:
     * {ueberstandBottom, ueberstandTop, hoehe}
     */
    _getHeight(bottom: boolean, top: boolean, anzahl = this.faecherAnzahl, hoehe = this.faecherHoehe) {
        const result = {
            ueberstand: this._getUeberstand(bottom, top),
            hoehe: 0
        };
        
        const fuge = APP.settings.getMinValue('fugen_abstand');

        if (this.hasFronts) {
            result.hoehe = anzahl * hoehe + (anzahl - 1) * fuge - result.ueberstand.bottom - result.ueberstand.top;
        } else {
            // Zu innenliegenden SK:
            // Wenn der Schubkasten eine Höhe von 200mm hat, ist das inkl. 30 mm Eingrifffuge.
            // Unten kommen noch 4 mm Fuge des unteren Schubkastens zum Boden hin dazu.
            // Bei 4 Schubkästen ist das Zwischenmaß also 4 x 200mm + 4mm Fuge unten = 804mm.
            result.hoehe = anzahl * hoehe + fuge;
        }
        return result;
    }

    _getUeberstand(bottom: boolean, top: boolean) {

        if (!this.hasFronts) {
            return {
                bottom: 0,
                top: 0,
            }
        }

        const fuge = APP.settings.getMinValue('fugen_abstand');
        const brettStaerke = APP.settings.getFloat('brett_staerke');
        const ueberstandUnten = APP.settings.getFloat('ueberstand_aussen_unten');
        const ueberstandOben = APP.settings.getFloat('ueberstand_aussen_oben');
        const aufschlagend = APP.settings.getFloat('aussenwand_vorsprung') === 0.0;

        let staerke = 0;
        bottom ? staerke = APP.settings.getFloat('boden_staerke')
        : top ? staerke = APP.settings.getFloat('deckel_staerke')
        : staerke = APP.settings.getFloat('brett_staerke');
        
        return {
            bottom: bottom
                ? staerke - ueberstandUnten
                : (brettStaerke - fuge) / 2,
            top: top
                ? (aufschlagend ? staerke - ueberstandOben : -fuge)
                : (brettStaerke - fuge) / 2
        }
       
    }

    // für partslist/Preisberechnung - Mass einer einzelnen Schublade
    get flaechenMass() {
        const result = this.size.clone();
        result.y = this.faecherHoehe;
        return result;
    }

    iterate(iterator) {
        super.iterate(iterator);
        this.drawers.forEach(x=>x.iterate(iterator));
        this.abstandsbretter.forEach(x=>x.iterate(iterator));
    }

}


